import { MOBILITY_LOGO } from './app/Utility/constants';
import { shouldDisplayDifferentLogo } from './app/Utility/functions';

const isNewYear = shouldDisplayDifferentLogo('Rosh Hashana');

const isPesach = shouldDisplayDifferentLogo('Pesach');

export const LOGO_TO_DISPLAY = isNewYear ? MOBILITY_LOGO.SHANATOVA : isPesach ? MOBILITY_LOGO.PESACH : MOBILITY_LOGO.DEFAULT;

document.getElementById('favicon').setAttribute('href', LOGO_TO_DISPLAY);

window.logo = window.MOBILITY_LOGO = LOGO_TO_DISPLAY;
